import React from "react";
import OpenFinance from "../../components/OpenFinance";

import "./style.css"

function PageOpenFinance() {

  return (
    <>
      <div className="centralizar">
        <OpenFinance />
      </div>
    </>
  );
}
export default PageOpenFinance;
